import {BaseApi} from "../BaseApi";

export class BaseModel {
    baseApi = new BaseApi();

    RouteName = "";

    AuthState = false;
    cookie = "";

}
